var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row heading justify-content-center mb-5 mt-5"},[_c('div',{staticClass:"col"},[_c('h1',{staticClass:"section-highlights headings serif"},[_vm._v(_vm._s(_vm.headingData.name))]),_vm._v(" "),_c('span',{staticClass:"h-line"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }